import React, { useState,useRef } from 'react'
import { jsPDF } from "jspdf";
import Moment from "react-moment";
import { resumeBuild } from "../../functions/apis"
import sing from '../../assets/images/karaoke.png'
import work from '../../assets/images/portfolio.png'
import edu from '../../assets/images/mortarboard.png'
import books from '../../assets/images/books.png'
import '../resume.css'
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';

import * as html2canvas from 'html2canvas';

function ResumePreview({ resumeData, onClickBack }) {
    const pdfExportComponent = useRef(null);
    function circle(range) {
        const ele = [];
        for (let i = 0; i < 5; i++) {
            let klass;
            if (range > i && range != null) {
                klass += " is-selected";
            }
            ele.push(<div key={i} className={`${klass} w-3 h-3 rounded-full border shadow-md`}></div>)
        }
        return ele
    }
    const [isResumeDownload, setIsResumeDownload] = useState(false)
    const doc = new jsPDF('p', 'pt', 'a4', true);
    // const doc = new jsPDF('p', 'pt', [1000, 1200]);
    let elem = document.getElementById('tests')
    const getPdf = async () => {
        doc.html(document.getElementById('pdf-jsx'), {
            callback: function (doc) {
                doc.output("dataurlnewwindow");
                // console.log(doc)
                // doc.save("resume.pdf")
                setIsResumeDownload(false)
            },
            image: { type: 'jpeg', quality: 0.95 },
            html2canvas: { scale: 1, useCORS: false },
        });
    }
    const saveResumeAndDownload = () => {
        setIsResumeDownload(true)
        resumeBuild(resumeData)
            .then(function (res) {
                getPdf()
            })
            .catch(function (err) {
                console.log(err)
                setIsResumeDownload(false)
            });
    }


    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
          pdfExportComponent.current.save();
        }
      };

    return (
        <>
            <div className='w-full overflow-hidden px-3'>
                <div className="my-0 mx-auto space-x-3" style={{ maxWidth: '598px' }}>
                    <button onClick={onClickBack} className=' font-medium text-base px-4 py-1 rounded text-white mb-2' style={{ backgroundColor: "var(--color-5)" }}>Back</button>
                    {/* <button onClick={saveResumeAndDownload} className=' font-medium text-base px-4 py-1 rounded text-white mb-2' style={{ backgroundColor: "var(--color-5)" }}>
                        {isResumeDownload ? 'Loading' : 'Download'}
                    </button> */}
                    <button onClick={exportPDFWithComponent} className=' font-medium text-base px-4 py-1 rounded text-white mb-2' style={{ backgroundColor: "var(--color-5)" }}>
                        {isResumeDownload ? 'Loading' : 'Download'}
                    </button>
                </div>
            </div>
            <div className='w-full overflow-auto px-3'>
                {/* <div className="my-0 mx-auto shadow  resumeBody"  id='pdf-jsx'> */}
                <PDFExport  ref={pdfExportComponent}>
                    <div className="my-0 mx-auto shadow  resumeBody">
                    <div className="my-0 mx-auto main-resume-con">
                        <div className="row bg-gray-200 no-gutters mb-2">
                            <div className="col-md-3 col-3 pr-1">
                                <div className='relative h-full'>
                                    {resumeData.profilepicture.status && <img src={resumeData.profilepicture.profilepicture} alt="profilepicture" className='w-full h-full' />}
                                    <div className="text-center">
                                        {resumeData.fullname.status && <span className="text-px">{resumeData.fullname.fullname}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-9 col-9 pl-1">
                                <div className="h-full flex flex-col">
                                    <span className="font-semibold block border-b border-gray-800 border-solid leading-8" style={{ fontSize: '15px' }}>Summary</span>
                                    {resumeData.bio.status && <span className="block text-gray-500 leading-3 " style={{ fontSize: '10px' }}>{resumeData.bio.bio}</span>}
                                    <div className="h-full flex flex-col" style={{ marginTop: '15px' }}>
                                        <div className="row no-gutters leading-none">
                                            <div className="col-md-6">
                                                <div className="row no-gutters">
                                                    <span>
                                                        <span className="font-semibold" style={{ fontSize: '10px' }}>Address :</span> {resumeData.address.status && <span className="" style={{ fontSize: '8px' }}>{resumeData.address.address}</span>}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row no-gutters">
                                                    <span>
                                                        <span className="font-semibold" style={{ fontSize: '10px' }}>Email :</span> {resumeData.email.status && <span className="" style={{ fontSize: '8px' }}>{resumeData.email.email}</span>}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row no-gutters">
                                                    <span>
                                                        <span className="font-semibold" style={{ fontSize: '10px' }}>Phone :</span> {resumeData.phone.status && <span className="" style={{ fontSize: '8px' }}>{resumeData.phone.phone}</span>}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row px-3">
                            <div className="col-md-7 col-7">
                                {resumeData.work.length > 0 && <div style={{ marginBottom: '15px' }}>
                                    <div className='flex items-center w-full border-b border-solid border-gray-300 pb-2'>
                                        <img src={work} alt="work" className='h-4 mr-2' />
                                        <span className="block uppercase font-semibold leading-none pb-2" style={{ fontSize: '12px' }}>WORK EXPERIENCE</span>
                                    </div>
                                    <div className="row space-y-4 no-gutters">
                                        {resumeData.work.map((workData, idx) => {
                                            return workData.status && <> <div key={idx} className="col-md-4 col-4 my-2">
                                                <div className='text-right'>
                                                    <span className='block uppercase text-sm font-bold leading-3' style={{ color: 'var(--color-5)', fontSize: '10px', marginBottom: '3px' }}>{workData.work_data.work_title}</span>
                                                    <span className='block  text-xs italic leading-3' style={{ fontSize: '8px' }}>(
                                                        <Moment format={"MMM YYYY"}>
                                                            {workData.work_data.start_date}
                                                        </Moment>-
                                                        {workData.work_data.end_date === null || workData.work_data.currently_working === "1" ? "Present" : <Moment format={"MMM YYYY"}>
                                                            {workData.work_data.end_date}
                                                        </Moment>})</span>
                                                </div>
                                            </div>
                                                <div className="col-md-8 col-8 my-2 pl-3">
                                                    <div>
                                                        <span className="block uppercase font-semibold" style={{ fontSize: '9px' }}>{workData.work_data.work_company}</span>
                                                        <span className="block lowercase" style={{ fontSize: '8px' }}>{workData.work_data.employment_type}</span>
                                                    </div>
                                                </div>
                                            </>
                                        })}
                                    </div>
                                </div>}
                                {/* education */}
                                {resumeData.education.length > 0 && <div style={{ marginBottom: '15px' }}>
                                    <div className='flex items-center w-full border-b border-solid border-gray-300'>
                                        <img src={edu} alt="work" className='h-4 mr-2' />
                                        <span className="block uppercase font-semibold leading-none pb-2" style={{ fontSize: '12px' }}>EDUCATION</span>
                                    </div>
                                    <div className="row space-y-4 no-gutters">
                                        {resumeData.education.map((educationData, idx) => {
                                            return educationData.status && <> <div key={idx} className="col-md-4 col-4 my-2">
                                                <div className='text-right'>
                                                    <span className='block uppercase text-sm font-bold leading-3' style={{ color: 'var(--color-5)', fontSize: '10px', marginBottom: '3px' }}>{educationData.edu_data.course_title}</span>
                                                    <span className='block  text-xs italic leading-3' style={{ fontSize: '8px' }}>(
                                                        <Moment format={"MMM YYYY"}>
                                                            {educationData.edu_data.start_date}
                                                        </Moment>-
                                                        {educationData.edu_data.end_date === null || educationData.edu_data.currently_working === "1" ? "Present" : <Moment format={"MMM YYYY"}>
                                                            {educationData.edu_data.end_date}
                                                        </Moment>}
                                                        )</span>
                                                </div>
                                            </div>
                                                <div className="col-md-8 col-8 my-2 pl-3">
                                                    <div>
                                                        <span className="block uppercase font-semibold" style={{ fontSize: '9px' }}>{educationData.edu_data.institute_name}</span>
                                                        <span className="block uppercase font-semibold mt-2" style={{ fontSize: '8px' }}>Grade : {educationData.edu_data.grade}</span>
                                                    </div>
                                                </div>
                                            </>
                                        })}
                                    </div>
                                </div>}
                                {/* publication */}
                                {(resumeData.publication.some((val) => val.status === true) || resumeData.certificate.some((val) => val.status === true)) && <>
                                    <div>
                                        {/* <div>
                                        <span className="block uppercase font-semibold border-b border-solid border-gray-300 pb-2 leading-none" style={{ fontSize: '12px' }}>PUBLICATION AND CERTIFICATION</span>
                                    </div> */}
                                        <div className='flex items-center w-full border-b border-solid border-gray-300'>
                                            <img src={books} alt="work" className='h-4 mr-2' />
                                            <span className="block uppercase font-semibold leading-none pb-2" style={{ fontSize: '12px' }}>PUBLICATION AND CERTIFICATION</span>
                                        </div>
                                        <div className="row space-y-3 no-gutters">
                                            {resumeData.publication.map((publicationData, idx) => {
                                                return publicationData.status && <> <div key={idx} className="col-md-4 col-4 my-2">
                                                    <div className='text-right'>
                                                        <span className='block uppercase text-sm font-bold leading-3' style={{ color: 'var(--color-5)', fontSize: '10px', marginBottom: '3px' }}>{publicationData.publication_data.title}</span>
                                                        <span className='block  text-xs italic leading-3' style={{ fontSize: '8px' }}>(
                                                            <Moment format={"MMM YYYY"}>
                                                                {publicationData.publication_data.dop}
                                                            </Moment>
                                                            )</span>
                                                    </div>
                                                </div>
                                                    <div className="col-md-8 col-8 my-2 pl-3">
                                                        <div>
                                                            <span className="block uppercase font-semibold" style={{ fontSize: '9px' }}>{publicationData.publication_data.publishers}</span>
                                                        </div>
                                                    </div>
                                                </>
                                            })}
                                            {resumeData.certificate.map((certificate_data, idx) => {
                                                return certificate_data.status && <> <div key={idx} className="col-md-4 col-4 my-1">
                                                    <div className='text-right'>
                                                        <span className='block uppercase text-sm font-bold leading-3' style={{ color: 'var(--color-5)', fontSize: '10px', marginBottom: '3px' }}>{certificate_data.certificate_data.title}</span>
                                                        <span className='block italic leading-3' style={{ fontSize: '8px' }}>(
                                                            <Moment format={"MMM YYYY"}>
                                                                {certificate_data.certificate_data.date}
                                                            </Moment>
                                                            )</span>
                                                    </div>
                                                </div>
                                                    <div className="col-md-8 col-8 pl-3">
                                                        <div>
                                                            <span className="block uppercase font-semibold" style={{ fontSize: '9px' }}>{certificate_data.certificate_data.user_label ? certificate_data.certificate_data.user_label : certificate_data.certificate_data.description}</span>
                                                        </div>
                                                    </div>
                                                </>
                                            })}
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="col-md-5 col-5">
                                {/* PROFESSIONAL SKILLS */}
                                {resumeData.skills.length > 0 && <div style={{ marginBottom: '15px' }}>
                                    <div>
                                        <span className="block uppercase font-semibold border-b border-solid border-gray-300 pb-2 leading-none" style={{ fontSize: '12px' }}>PROFESSIONAL SKILLS</span>
                                    </div>
                                    <div className="row space-y-4 my-1">
                                        {resumeData.skills.map((skillsData, idx) => {
                                            return <>
                                                <div className="col-md-12 col-12 my-2" key={idx}>
                                                    <div className="row items-center">
                                                        <div className="col-md-4 col-4">
                                                            <div>
                                                                <span className='block' style={{ fontSize: '9px' }}>{skillsData.title}</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8 col-8">
                                                            <div className="flex space-x-2">
                                                                {circle(skillsData.skillRange)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        })}
                                    </div>
                                </div>}
                                {/* PROjects */}
                                {resumeData.projects.length > 0 && <div style={{ marginBottom: '15px' }}>
                                    <div>
                                        <span className="block uppercase font-semibold border-b border-solid border-gray-300 pb-2 leading-none" style={{ fontSize: '12px' }}>PROJECTS</span>
                                    </div>
                                    <div className="row space-y-1">
                                        {resumeData.projects.map((projects_data, idx) => {
                                            return projects_data.status && <> <div key={idx} className="col-md-12 col-12">
                                                <div>
                                                    <span className='block uppercase text-sm font-bold leading-3' style={{ color: 'var(--color-5)', fontSize: '10px', marginBottom: '3px' }}>{projects_data.projects_data.title}</span>
                                                    <span className='block italic leading-3' style={{ fontSize: '8px' }}>(
                                                        <Moment format={"MMM YYYY"}>
                                                            {projects_data.projects_data.start_date}
                                                        </Moment>-
                                                        {projects_data.projects_data.end_date === null || projects_data.projects_data.currently_working === "1" ? "Present" : <Moment format={"MMM YYYY"}>
                                                            {projects_data.projects_data.end_date}
                                                        </Moment>}
                                                        )</span>
                                                </div>
                                            </div>
                                                <div className="col-md-8 col-8 mb-2">
                                                    <div>
                                                        <a href={projects_data.projects_data.project_url} className="block font-semibold" style={{ fontSize: '8px' }}>{projects_data.projects_data.project_url}</a>
                                                    </div>
                                                </div>
                                            </>
                                        })}
                                    </div>
                                </div>}
                                {/* Extra curricular */}
                                {resumeData.extracur.length > 0 && <div style={{ marginBottom: '15px' }}>
                                    <div>
                                        <span className="block uppercase font-semibold border-b border-solid border-gray-300 pb-2 leading-none" style={{ fontSize: '12px' }}>Extra curricular</span>
                                    </div>
                                    <div className="row space-y-1">
                                        {resumeData.extracur.map((extracur_data, idx) => {
                                            return extracur_data.status && <> <div key={idx} className="col-md-12 col-12 my-2">
                                                <div className="flex flex-col">
                                                    <span className='block' style={{ fontSize: '9px' }}>{extracur_data.extracuricular_data.title}</span>
                                                    <span className='block' style={{ fontSize: '9px' }}>{extracur_data.extracuricular_data.description}</span>
                                                </div>
                                            </div>
                                            </>
                                        })}
                                    </div>
                                </div>}
                                {/* Hobbiles */}
                                {resumeData.hobbies.length > 0 && <div style={{ marginBottom: '15px' }}>
                                    <div>
                                        <span className="block uppercase font-semibold border-b border-solid border-gray-300 pb-2 leading-none" style={{ fontSize: '12px' }}>HOBBIES AND INTERESTS</span>
                                    </div>
                                    <div className="row space-y-1 mb-1">
                                        <div className="col-md-12 col-12 my-2">
                                            <div className="flex items-center space-x-2">
                                                {resumeData.hobbies.map((hobbies_data, idx) => {
                                                    return <>
                                                        <div className='bg-gray-200 rounded-md '>
                                                            <span key={idx} className='px-2 block mb-2' style={{ fontSize: '9px' }}>{hobbies_data.title}</span>
                                                        </div>
                                                    </>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    </div>
                </PDFExport>
            </div>
        </>
    )
}

export default ResumePreview
